import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { SummaryService } from 'src/app/service/asn/summary.service';

@Component({
    selector: 'app-summary-history-logs',
    templateUrl: './summary-history-logs.component.html',
    styleUrls: ['./summary-history-logs.component.scss'],
    standalone: false
})
export class SummaryHistoryLogsComponent implements OnInit {
  gridApi: any;
  icons: {};
  frameworkComponents: {};
  context: {};

  eventType: string;
  invoiceNum: number;
  supplier: number;
  po: number;
  poLine: number;
  backNum: string;
  columnDefs = [];
  rowData = [];
  errormsg: string
  defaultColDef: {};
  constructor(public dialogRef: MatDialogRef<SummaryHistoryLogsComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
    private readonly summaryService: SummaryService, private readonly ngxUiLoaderService: NgxUiLoaderService) {
    this.context = {
      componentParent: this
    };
    this.frameworkComponents = {};
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
  }
  ngOnInit(): void {
    this.eventType = this.dataStore.eventType
    this.po = this.dataStore.po;
    this.poLine = this.dataStore.poLine;
    this.backNum = this.dataStore.backNum;
    this.invoiceNum = this.dataStore.invoiceNum;
      this.supplier = this.dataStore.supplier
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
    this.columnDefs = [
      {
        headerName: "Invoice", field: "invoiceNum",
        sortable: true, unSortIcon: true, autoHeight: true, wrapText: true,
      },
      {
        headerName: "Import", field: "importTime", autoHeight: true, wrapText: true,cellStyle: {textAlign: 'center'}
      },
      {
        headerName: "Previous Qty", field: "shipQty", cellStyle: {textAlign: 'center'} , autoHeight: true, wrapText: true,
      }
    ];
    this.getHistoryLogs(this.po, this.poLine, this.backNum)
  }


  getHistoryLogs(po, poLine, backNum): void {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    this.summaryService.loadDataSummaryHistoryLogs(Number(po), poLine, backNum).subscribe(
      response => {
        this.rowData = response
        this.gridApi?.setGridOption('rowData', this.rowData);
        this.gridApi?.resetRowHeights();
        // this.gridApi.onRowHeightChanged()
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      }, _error => {
        this.errormsg = this.constants.APIErrorMessage
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      }
    );
  }

  getRowHeight() {
    return 30;
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
}
